// extracted by mini-css-extract-plugin
module.exports = {"switchRoot":"Switch_switchRoot__o8GI_"};